export default function RankingSection() {
  const rankings = [
    {
      rank: 1,
      title: '星辰变 第六季',
      category: '玄幻修仙',
      heat: '本周热度飙升',
      isHot: true,
      desc: '秦羽踏足神界，新的冒险篇章正式开启，制作水准再度提升。',
    },
    {
      rank: 2,
      title: '斗破苍穹 年番',
      category: '热血战斗',
      heat: '持续霸榜',
      isHot: true,
      desc: '萧炎中州风云再起，炼药大会精彩对决，年番稳定更新中。',
    },
    {
      rank: 3,
      title: '完美世界',
      category: '东方玄幻',
      heat: '人气爆棚',
      isHot: true,
      desc: '石昊征战上界，剧情进入高潮阶段，战斗场面燃爆全网。',
    },
    {
      rank: 4,
      title: '凡人修仙传',
      category: '修仙武侠',
      heat: '口碑佳作',
      isHot: false,
      desc: '韩立星海历练，3D画面质感出众，被誉为国漫制作天花板。',
    },
    {
      rank: 5,
      title: '一念永恒 第三季',
      category: '搞笑修仙',
      heat: '新番热播',
      isHot: true,
      desc: '白小纯搞笑逆袭之路继续，轻松幽默的修仙日常让人欲罢不能。',
    },
    {
      rank: 6,
      title: '仙王的日常生活 第四季',
      category: '校园搞笑',
      heat: '强势归来',
      isHot: false,
      desc: '王令回归，校园搞笑日常再升级，新角色加入带来更多欢乐。',
    },
  ];

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            51动漫热度榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时追踪51动漫网与51动漫网站用户观看热度，发现最受欢迎的国产动漫
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankings.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              className={`group flex items-center gap-4 md:gap-6 p-4 md:p-5 cursor-pointer transition-all duration-200 ${
                idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-50 rounded-lg`}
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`font-heading text-xl md:text-2xl ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                          ? 'text-accent-500'
                          : 'text-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="font-heading text-lg md:text-xl text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.isHot && (
                    <span className="flex-shrink-0 px-2 py-0.5 bg-primary-100 text-primary-600 text-xs font-medium rounded-full">
                      HOT
                    </span>
                  )}
                </div>
                <p className="text-xs md:text-sm text-foreground-600 truncate">
                  {item.desc}
                </p>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full">
                  {item.category}
                </span>
                <p className="text-xs text-foreground-500 mt-1">{item.heat}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}